const menuItems = document.querySelectorAll('.header__menu-li');

if (menuItems && menuItems.length) {
  for (const menuItem of menuItems) {
    const menuItemLink = menuItem.querySelector('a');
    const hasSubMenu = menuItem.querySelector('ul');
    if (hasSubMenu) {
      menuItemLink.classList.add('header__menu-item--has-children');
    }
  }
}
